export const THEME_CLASS_NAMES = {
  DARK: 'dark',
  LIGHT: 'light',
};
